import axios from 'axios'

import * as utils from '../utils'

axios.defaults.withCredentials = true

const apiUrl = process.env.NODE_ENV === 'production' ? 'https://meetbot.me/api' : 'http://localhost:3030/api'

export function apiGetUser(id, language_code = 'en') {
  return axios.post(`${apiUrl}/users/get`, {id, language_code})
    .then(utils.handleAxiosSuccess)
    .catch(utils.handleAxiosError)
}

export function apiSearch(params = {}) {
  return axios.post(`${apiUrl}/users/search`, params)
    .then(utils.handleAxiosSuccess)
    .catch(utils.handleAxiosError)
}

export function apiCount(filter) {
  return axios.post(`${apiUrl}/users/count`, filter)
    .then(utils.handleAxiosSuccess)
    .catch(utils.handleAxiosError)
}

export function apiCheckAuth() {
  return axios.post(`${apiUrl}/common/checkAuth`, {}, {withCredentials: true})
    .then(utils.handleAxiosSuccess)
    .catch(utils.handleAxiosError)
}

export function apiLogin(params) {
  return axios.post(`${apiUrl}/common/login`, params)
    .then(utils.handleAxiosSuccess)
    .catch(utils.handleAxiosError)
}

export function apiLogout() {
  return axios.post(`${apiUrl}/common/logout`)
    .then(utils.handleAxiosSuccess)
    .catch(utils.handleAxiosError)
}
